const baseURL = "https://api.sweepersandfloorscrubbers.net";
// Endpoints for geolocation_controller
const geolocation_index = `${baseURL}/geolocation`;
// const geolocation_get_geolocations = `${baseURL}/geolocation/get_geolocations`;
const geolocation_create = `${baseURL}/geolocation`;
// Function to fetch location based on IP address using an external service
function getVisitorIP() {
  fetch("https://api.ipify.org?format=json")
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      console.log("show ip address at request js", data.ip);
      getGeolocationInfo(data.ip)
    })

    .catch((error) => {
      console.error("There was a problem fetching the IP address:", error);
      return null;
    });
}
getVisitorIP();
// Function to get geolocation information using the IP address
function getGeolocationInfo(ipAddress) {
  const token = "ffa375359c2427";
  const apiUrl = `https://ipinfo.io/${ipAddress}?token=${token}`;

  return fetch(apiUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      console.log("geolocation for given ip address", data)
      createGeolocation(data);
    })
    .catch((error) => {
      console.error("There was a problem fetching geolocation info:", error);
      return null;
    });
}

function createGeolocation(params) {
  const data = {
    ip_address: params.ip,
    country_code: params.country,
    region: params.region,
    city: params.city,
    latitude: params.loc,
    longitude: params.loc,
    postal_code: params.postal,
    counter: 1,
  };
  const headers = {
    "Content-Type": "application/json",
  };
  fetch(geolocation_create, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("geolocation_create response", data);
      // getGeolocation();
    })
    .catch((error) => {
      console.error("Error in geolocation:", error);
    });
}

// function getGeolocation() {
//   const data = {
//     customerId: 1,
//   };
//   const headers = {
//     "Content-Type": "application/json",
//   };
//   fetch(geolocation_get_geolocations, {
//     method: "POST",
//     headers: headers,
//     body: JSON.stringify(data),
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       console.log("geolocation_get_geolocations response hhh", data);
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });
// }
